import { Node, mergeAttributes } from '@tiptap/core';

export const ImageBlockServerside = Node.create({
  name: 'imageBlock',
  group: 'block',
  content: 'inline*',

  parseHTML() {
    return [
      {
        tag: 'img[src*="tiptap.dev"]:not([src^="data:"]), img[src*="windows.net"]:not([src^="data:"])',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div', // Create a div wrapper
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        class: 'image-wrapper',
      }), // Add any desired attributes to the wrapper
    ];
  },

  // renderHTML({ HTMLAttributes }) {
  //   return [
  //     'img',
  //     mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
  //   ];
  // },

  addAttributes() {
    return {
      'data-id': { default: null },
      src: {
        default: '',
        parseHTML: element => element.getAttribute('src'),
        renderHTML: attributes => ({
          src: attributes.src,
        }),
      },
      width: {
        default: '100%',
        parseHTML: element => element.getAttribute('data-width'),
        renderHTML: attributes => ({
          'data-width': attributes.width,
        }),
      },
      align: {
        default: 'center',
        parseHTML: element => element.getAttribute('data-align'),
        renderHTML: attributes => ({
          'data-align': attributes.align,
        }),
      },
      alt: {
        default: undefined,
        parseHTML: element => element.getAttribute('alt'),
        renderHTML: attributes => ({
          alt: attributes.alt,
        }),
      },
    };
  },
});
